import type { EntityId } from "@/charting_library/charting_library";
import { Datasets, Subcharts } from "../../../types";
import type { LibraryChartState } from "../types";

export const isStudyIncluded = (
	chartState: Partial<LibraryChartState>,
	studyName: string,
) => {
	if (!chartState.charts) return false;

	for (const pane of chartState.charts[0].panes) {
		for (const source of pane.sources) {
			if (
				source.metaInfo?.name === studyName ||
				source.metaInfo?.description === studyName
			) {
				return true;
			}
		}
	}
	return false;
};

export const findTimingMomentumStudyId = (
	chartState: Partial<LibraryChartState>,
): EntityId | undefined => {
	if (!chartState.charts?.length) return undefined;

	for (const pane of chartState.charts[0].panes) {
		for (const source of pane.sources) {
			if (source.metaInfo?.description === "Timing Momentum") {
				return source.id;
			}
		}
	}

	return undefined;
};

export const isPanelWithCustomIndicator = (
	panelName: string | undefined,
): boolean => {
	if (!panelName) return false;
	const trimmed = panelName.trim();

	return (
		Object.values(Subcharts).includes(trimmed as Subcharts) ||
		Object.values(Datasets).includes(trimmed as Datasets)
	);
};
